





























import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import AccountCertificateFormDDC from '@/modules/AccountCertificate/components/forms/AccountCertificateFormDDC.vue'
import AccountCertificateFormDriving from '@/modules/AccountCertificate/components/forms/AccountCertificateFormDriving.vue'
import AccountCertificateFormMVR from '@/modules/AccountCertificate/components/forms/AccountCertificateFormMVR.vue'
import AccountCertificateFormSSN from '@/modules/AccountCertificate/components/forms/AccountCertificateFormSSN.vue'
import AccountCertificateFormID from '@/modules/AccountCertificate/components/forms/AccountCertificateFormID.vue'
import AccountCertificateFormOther from '@/modules/AccountCertificate/components/forms/AccountCertificateFormOther.vue'
import AccountCertificateFormInfo from '@/modules/AccountCertificate/components/forms/AccountCertificateFormInfo.vue'
import AccountCertificateFormType from '@/modules/AccountCertificate/components/forms/AccountCertificateFormType.vue'

import { newAccountCertificate, editAccountCertificate } from '@/modules/AccountCertificate/gql/account-certificate.gql'
import { AccountCertificate, AccountCertificateType } from '@/modules/AccountCertificate/interfaces/account-certificate'
import {
  IAccountCertificateDDCInput, IAccountCertificateDrivingInput, IAccountCertificateIDInput, IAccountCertificateInfoInput, IAccountCertificateMVRInput, IAccountCertificateOtherInput, IAccountCertificateSSNInput, IAccountCertificateTypeInput
} from '@/modules/AccountCertificate/interfaces/account-certificate-form'
import { typeKeys } from '@/modules/AccountCertificate/helpers/account-certificate'

@Component({
  components: {
    AccountCertificateFormType,
    AccountCertificateFormID,
    AccountCertificateFormDDC,
    AccountCertificateFormMVR,
    AccountCertificateFormInfo,
    AccountCertificateFormSSN,
    AccountCertificateFormOther,
    AccountCertificateFormDriving,
    AppDialog,
    AppSteps
  }
})
export default class AccountCertificateForm extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => AccountCertificate }) readonly accountCertificate!: AccountCertificate
  @Prop(Number) readonly accountId!: number
  @Prop(Boolean) loading!: boolean

  showDialog = false

  loadingValue = false

  stepIndex = 0
  type: AccountCertificateType = AccountCertificateType.ID_CARD

  AccountCertificateType = AccountCertificateType

  infoInput: IAccountCertificateInfoInput = {
    name: '',
    notes: ''
  }

  typeInput: IAccountCertificateTypeInput = {
    typeIdx: 0
  }

  idInput: IAccountCertificateIDInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    idNumber: ''
  }

  ssnInput: IAccountCertificateSSNInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    ssn: ''
  }

  drivingInput: IAccountCertificateDrivingInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    licenseNumber: '',
    expirationDate: ''
  }

  ddcInput: IAccountCertificateDDCInput = {
    expirationDate: ''
  }

  mvrInput: IAccountCertificateMVRInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    licenseNumber: '',
    expirationDate: ''
  }

  otherInput: IAccountCertificateOtherInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    idNumber: '',
    licenseNumber: '',
    expirationDate: '',
    ssn: ''
  }

  get steps () {
    switch (this.type) {
      case AccountCertificateType.ID_CARD:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['Id Card', 770, 381]
        ]
      case AccountCertificateType.SSN:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['SSN', 770, 381]
        ]
      case AccountCertificateType.DRIVING_LICENSE:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['Driving License', 770, 441]
        ]
      case AccountCertificateType.DDC:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['DDC', 770, 321]
        ]
      case AccountCertificateType.MVR:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['MVR', 770, 441]
        ]
      default:
        return [
          ['Certificate Type', 770, 321],
          ['Certificate Info', 770, 421],
          ['Other', 770, 501]
        ]
    }
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.accountCertificate
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.accountCertificate ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex === this.steps.length - 1
  }

  get formTypeMap () {
    return {
      ID_CARD: this.idInput,
      SSN: this.ssnInput,
      DRIVING_LICENSE: this.drivingInput,
      DDC: this.ddcInput,
      MVR: this.mvrInput,
      OTHER: this.otherInput
    }
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    } else {
      this.clearForm()
    }
    this.showDialog = val
  }

  @Watch('loading')
  onLoadingValueChanged (val: boolean) {
    this.loadingValue = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.accountCertificate) {
      const {
        name,
        notes,
        type,
        idNumber,
        ssn,
        firstName,
        middleName,
        lastName,
        licenseNumber,
        expirationDate
      } = this.accountCertificate

      this.infoInput = {
        name,
        notes
      }

      this.typeInput = {
        typeIdx: typeKeys.findIndex(key => key === type)
      }

      this.type = type

      this.idInput = {
        firstName,
        middleName,
        lastName,
        idNumber
      }

      this.ssnInput = {
        firstName,
        middleName,
        lastName,
        ssn
      }

      this.drivingInput = {
        firstName,
        middleName,
        lastName,
        licenseNumber,
        expirationDate
      }

      this.ddcInput = {
        expirationDate
      }

      this.mvrInput = {
        firstName,
        middleName,
        lastName,
        licenseNumber,
        expirationDate
      }

      this.otherInput = {
        firstName,
        middleName,
        lastName,
        licenseNumber,
        expirationDate,
        ssn,
        idNumber
      }
    } else {
      this.clearForm()
    }
  }

  onTypeChanged (val: number) {
    this.type = typeKeys[val] as AccountCertificateType
  }

  handleStepClick (index: number) {
    if (!this.accountCertificate) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loadingValue = true
      if (this.accountCertificate && this.accountCertificate.id !== -1) {
        this.handleUpdateAccountCertificate()
      } else {
        this.handleCreateAccountCertificate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    } else {
      this.showDialog = false
    }
  }

  async handleCreateAccountCertificate () {
    const {
      infoInput: {
        name,
        notes
      }
    } = this

    const type = this.type

    const typeForm = this.formTypeMap[type]

    let input = {
      name,
      notes,
      type,
      ...typeForm
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: newAccountCertificate,
        variables: {
          input,
          accountId: this.accountId
        }
      })

      const { id } = res.data.newAccountCertificate
      this.onSuccess(id)
    } catch (e) {
      this.loadingValue = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdateAccountCertificate () {
    const {
      infoInput: {
        name,
        notes
      }
    } = this

    const type = this.type

    const typeForm = this.formTypeMap[type]

    let input = {
      name,
      notes,
      type,
      ...typeForm
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: editAccountCertificate,
        variables: {
          input,
          accountCertificateId: +this.accountCertificate.id
        }
      })
      this.onSuccess(-1)
    } catch (e) {
      this.loadingValue = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loadingValue = false
    this.infoInput = {
      name: '',
      notes: ''
    }

    this.typeInput = {
      typeIdx: 0
    }

    this.idInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      idNumber: ''
    }

    this.ssnInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      ssn: ''
    }

    this.drivingInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      licenseNumber: '',
      expirationDate: ''
    }

    this.ddcInput = {
      expirationDate: ''
    }

    this.mvrInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      licenseNumber: '',
      expirationDate: ''
    }

    this.otherInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      idNumber: '',
      licenseNumber: '',
      expirationDate: '',
      ssn: ''
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (id = -1) {
    return id
  }
}
